import { render } from "./FrameGrid.vue?vue&type=template&id=618301c0"
import script from "./FrameGrid.vue?vue&type=script&lang=js"
export * from "./FrameGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__